module.exports = __webpack_public_path__ + "img/addRow.7b95cbe6.svg";